<div class="groups-wrapper">
    @if (job.task_groups_preload?.length > 0) {
        @for (group of job.task_groups_preload; track group) {
            <ng-container
                [ngTemplateOutlet]="template"
                [ngTemplateOutletContext]="{ group: group }">
            </ng-container>
        }
    }
    @else {
        @for (group of job.task_groups; track group) {
            <ng-container
                [ngTemplateOutlet]="template"
                [ngTemplateOutletContext]="{ group: group }">
            </ng-container>
        }
    }
</div>

<ng-template #template let-group="group">
    <div class="group-pill" [ngClass]="{ 'current': group.name === job.current_group, 'completed': group.completed }"
    pTooltip="{{ group.owner ? group.owner.full_name  : 'Unassigned' }}: {{ group.name }}" tooltipPosition="top">
        @if (group.owner) {
        <img src="{{ group.owner?.pictureUrl }}" />
        }
        @else {
            <img src="assets/img/avatar_default.png" />
        }
        @if (![undefined, null].includes(group.due_date)) {
            <span>{{ getDueDate(group.due_date) | amDateFormat: "MMM, Do YYYY" }}</span>
        }
        @else {
            <span>{{ group.name }}</span>
        }
        <i class="tio-poi" *ngIf="group.name === job.current_group"></i>
    </div>
</ng-template>